'use client';

import React from 'react';
import { getFormattedPriceWithLocaleCurrency } from '@/src/lib/product/business/product-prices.ts';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import Loading from '@/src/app/components/LoadingSpinner/LoadingSpinner.tsx';
import { useYourPriceContext } from '@/src/app/components/Providers/context/YourPriceContext.tsx';
import ProductInfoTableRow from '@/src/app/[country]/[lang]/shop/[...segments]/(product-details)/components/ProductInfoTable/ProductInfoTableRow.tsx';

function YourPrice({
  lang,
  productMeasurementUnit,
  dict,
}: {
  lang: string;
  productMeasurementUnit: string | undefined;
  dict: Dictionary;
}) {
  const { isLoading, yourPrice, error } = useYourPriceContext();

  if (isLoading) {
    return (
      <ProductInfoTableRow
        label={dict.product.yourPrice}
        value={
          <div className="h-3 inline-block">
            <Loading small />
          </div>
        }
        valueTestId="your-price"
        priority
      />
    );
  }

  if (error || !yourPrice?.items.length) {
    return (
      <ProductInfoTableRow
        label={dict.product.yourPrice}
        value={<span className="text-danger font-normal!">{dict.product.yourPriceError}</span>}
        valueTestId="your-price"
        priority
      />
    );
  }

  return (
    <ProductInfoTableRow
      label={dict.product.yourPrice}
      value={
        <>
          {getFormattedPriceWithLocaleCurrency(yourPrice.items[0].netPrice || 0, yourPrice.currencyIsoCode, lang)}
          {productMeasurementUnit ? `/${productMeasurementUnit}` : null}
        </>
      }
      valueTestId="your-price"
      priority
    />
  );
}

export default YourPrice;
